import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15 0C6.728 0 0 6.731 0 15s6.728 15 15 15 15-6.728 15-15S23.268 0 15 0m-1.501 26.893a11.97 11.97 0 0 1-7.851-4.395h7.85zm0-7.393H3.884a11.8 11.8 0 0 1-.777-2.999h10.395V19.5zm0-6.001H3.103c.133-1.048.396-2.052.777-2.999h9.615V13.5zm0-5.997H5.648a11.97 11.97 0 0 1 7.85-4.395zM16.5 26.893V3.107C22.408 3.848 26.998 8.895 26.998 15S22.408 26.152 16.5 26.893"
    }, null, -1)
  ]))]))
}
export default { render: render }